import { HomeHeader } from "./components/HomeHeader";
import { HomeSearch } from "./components/HomeSearch";
import { BacklistLinks } from "./components/BacklistLinks";
import { EvaluationResults } from "./components/EvaluationResults";
import { RecentProjects } from "./components/RecentProjects/RecentProjects";
import { UpcomingSeasonalEvents } from "./components/seasonalEvents/UpcomingSeasonalEvents";
import { UploadManuscript } from "../UploadManuscript";

export const HomePage = () => {
  return (
    <div>
      <div className="-mx-16 -mt-8 mb-8 bg-secondary-25 flex flex-col justify-center items-center gap-4 py-14 px-10">
        <HomeHeader />
        <HomeSearch />
        <UpcomingSeasonalEvents />
      </div>

      <div className="w-full bg-white space-y-10">
        <BacklistLinks />

        <RecentProjects />
        <UploadManuscript />
        <EvaluationResults />
      </div>
    </div>
  );
};
